import { doc, getDoc, setDoc, getFirestore, serverTimestamp } from "firebase/firestore";
import firebaseApp from "../../firebase/credenciales";
import { CONT_COLLECTIONS } from "./collections";

const db = getFirestore(firebaseApp);

const cleanText = (v) => (v == null ? "" : String(v).trim());

/**
 * Creates an authorization document for a specific SIRE file hash.
 */
export const crearAutorizacionPresentacion = async ({
  rucEmpresa,
  periodo,
  tipo,
  archivoObj,
  usuario,
  ip = "",
  userAgent = "",
  motivo = "",
}) => {
  const ruc = cleanText(rucEmpresa);
  const per = cleanText(periodo);
  const tip = cleanText(tipo).toUpperCase();

  if (!ruc || !per || !tip) {
    throw new Error("RUC, período y tipo de libro son obligatorios para autorizar.");
  }
  if (!archivoObj || !archivoObj.hash_sha256 || !archivoObj.version) {
    throw new Error("El archivo contable y su Hash SHA-256 son obligatorios para autorizar.");
  }

  const hash = cleanText(archivoObj.hash_sha256);
  const authId = `${ruc}_${per}_${tip}_${hash}`;
  const authRef = doc(db, CONT_COLLECTIONS.SIRE_AUTORIZACIONES, authId);

  const payload = {
    ruc_empresa: ruc,
    periodo: per,
    tipo_libro: tip,
    version_archivo: Number(archivoObj.version || 1),
    hash_archivo: hash,
    usuario_autorizador: cleanText(usuario),
    fecha_autorizacion: serverTimestamp(),
    estado: "AUTORIZADO",
    ip: cleanText(ip),
    user_agent: cleanText(userAgent),
    motivo: cleanText(motivo),
    created_at: serverTimestamp(),
  };

  await setDoc(authRef, payload);
  return { id: authId, ...payload };
};

/**
 * Retrieves the authorization for a specific RUC, period, type, and hash.
 */
export const obtenerAutorizacionPresentacion = async (rucEmpresa, periodo, tipo, hash) => {
  const ruc = cleanText(rucEmpresa);
  const per = cleanText(periodo);
  const tip = cleanText(tipo).toUpperCase();
  const h = cleanText(hash);

  if (!ruc || !per || !tip || !h) return null;

  const authId = `${ruc}_${per}_${tip}_${h}`;
  const ref = doc(db, CONT_COLLECTIONS.SIRE_AUTORIZACIONES, authId);
  const snap = await getDoc(ref);

  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
};
